import type { GuComment } from "@/mocks/events";

const formatLikes = (value: number) =>
  value >= 10000 ? `${(value / 10000).toFixed(1)}万` : `${value.toLocaleString("zh-CN")}`;

interface CommentSectionProps {
  highlight: GuComment;
  comments: GuComment[];
  total: number;
}

export default function CommentSection({ highlight, comments, total }: CommentSectionProps) {
  return (
    <section id="comments" className="scroll-mt-24">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950">评论区现场</h2>
          <p className="mt-1 text-sm text-foreground-600">
            从高赞到翻车，这里是这场瓜真正的战场。
          </p>
        </div>
        <span className="shrink-0 text-xs font-medium text-foreground-500">
          共 {total.toLocaleString("zh-CN")} 条评论
        </span>
      </div>

      <div className="mt-5 rounded-lg border-l-4 border-primary-500 bg-primary-50 p-5">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-bold text-background-50">
            {highlight.badge}
          </span>
          <span className="text-sm font-bold text-foreground-950">{highlight.author}</span>
          <span className="text-xs text-foreground-500">{highlight.time}</span>
        </div>
        <p className="mt-3 font-heading text-base leading-relaxed text-foreground-900">
          {highlight.content}
        </p>
        <p className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
          <span className="flex items-center gap-1 font-semibold">
            <i className="ri-thumb-up-fill text-primary-600" />
            {formatLikes(highlight.likes)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {highlight.replies} 条回复
          </span>
        </p>
      </div>

      <ul className="mt-5 flex flex-col gap-3">
        {comments.map((comment, index) => (
          <li
            key={`${comment.author}-${index}`}
            className="gu-rise rounded-lg border border-background-200 bg-background-100 p-5"
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-sm font-black text-background-50">
                {comment.author.slice(0, 1)}
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950">
                  {comment.author}
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] font-semibold text-foreground-700">
                    {comment.badge}
                  </span>
                </span>
                <span className="block text-xs text-foreground-500">{comment.time}</span>
              </span>
              <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-foreground-600">
                <i className="ri-thumb-up-line text-primary-600" />
                {formatLikes(comment.likes)}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-800">{comment.content}</p>
            <p className="mt-2 text-xs text-foreground-500">
              {comment.replies} 条回复 · 已被热评区收录
            </p>
          </li>
        ))}
      </ul>

      <p className="mt-5 rounded-lg border border-dashed border-background-300 bg-background-100 px-5 py-4 text-xs leading-relaxed text-foreground-500">
        以上评论均为公开可⻅内容的整理与节选，观点归原作者所有。如果你发现其中有失实或不当信息，欢迎通过页脚邮箱反馈，我们会及时处理。
      </p>
    </section>
  );
}